import { useEffect, useState } from "react";

import { getFiltersFromStorage } from "@/components/AgendaFilters/utils/getFiltersFromStorage";

export const useInitializeStoredDurationFilter = (
  facilityId: string | null,
  setDurationFilter: (durationFilter: number | undefined) => void
) => {
  const [filterLoaded, setFilterLoaded] = useState(false);
  useEffect(() => {
    if (!facilityId || filterLoaded) {
      return;
    }

    const loadFilters = async () => {
      try {
        const storedDurationFilter = await getFiltersFromStorage(
          `x-whoosh-${facilityId}-duration-filter`
        );
        if (storedDurationFilter?.trim()) {
          const parsedDurationFilter = parseInt(storedDurationFilter, 10);
          if (!isNaN(parsedDurationFilter) && parsedDurationFilter > 0) {
            setDurationFilter(parsedDurationFilter);
          }
        }
      } catch (error) {}
    };
    loadFilters().finally(() => {
      setFilterLoaded(true);
    });
  }, [facilityId, setDurationFilter, filterLoaded]);
};
